import { optionalTrimmedNullableEmail } from './optional-trimmed-nullable-email.js';
/** Edit-form alias of `optionalTrimmedNullableEmail` (same blank → null behavior). */
export const optionalEditFormTrimmedEmail = optionalTrimmedNullableEmail;
//# sourceMappingURL=optional-edit-form-trimmed-email.js.map